@if (!locationsLoaded()) {
  <ngx-skeleton-loader
    [theme]="{ marginBottom: '5px', height: '30px' }"
    count="10"
  />
} @else {
  <cdk-virtual-scroll-viewport
    class="overflow-auto"
    [changeTrigger]="dataSource"
    [ngClass]="{
      'fill-available-height': fillAvailableHeight(),
      'fixed-scroll': isInjected() && !fillAvailableHeight(),
    }"
    [tableId]="tableId()"
    avsVirtualTableScrollNormalizer
    itemSize="1"
  >
    <cdk-virtual-scroll-viewport-wrapper>
      <table
        id="sites-table"
        class="main-table"
        [dataSource]="dataSource"
        [ngClass]="{ 'no-actions-table': userRole() === eUserRolesIds.ReadOnly }"
        mat-table
        matSort
        matSortActive="friendlyName"
        matSortDirection="asc"
      >
        <!-- Number Column -->
        <ng-container matColumnDef="index">
          <th
            *matHeaderCellDef
            mat-header-cell
          >№
          </th>
          <td
            *matCellDef="let index = index"
            mat-cell
          >
            {{ index + 1 }}
          </td>
        </ng-container>

        <!-- Building Name Column -->
        <ng-container matColumnDef="friendlyName">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            sortActionDescription="Sort by building name"
          >
            Building Name
          </th>
          <td
            *matCellDef="let element"
            data-cy="building-name"
            mat-cell
          >
            <a
              class="underline"
              [routerLink]="['/dashboard', element.id]"
            >{{ element.friendlyName }}</a>
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            sortActionDescription="Sort by status"
          >Status
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            <app-entity-status [status]="element.status" />
          </td>
        </ng-container>

        <!-- Address Column -->
        <ng-container matColumnDef="address">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            sortActionDescription="Sort by address"
          >Address
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            {{ element.address.streetAddress }}, {{ element.address.city }}, {{ element.address.stateProvince }},
            {{ element.address.postalCode }}, {{ element.address.country }}
          </td>
        </ng-container>

        <!-- Incident Column -->
        <ng-container matColumnDef="incidents">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
          >Incidents
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            @if (isLocationsSummariesLoading()) {
              <ngx-skeleton-loader [theme]="{ height: '36px', marginBottom: 0, verticalAlign: 'top' }" />
            }
            @if (element.status === eEntityStatus.Active && !isLocationsSummariesLoading()) {
              <avs-incident-severity-count
                [critical]="element.incidentCountBySeverity.critical"
                [major]="element.incidentCountBySeverity.major"
                [minor]="element.incidentCountBySeverity.minor"
                variant="icon"
              />
            }
          </td>
        </ng-container>

        <!-- Device Status Column -->
        <ng-container matColumnDef="deviceStatus">
          <th
            *matHeaderCellDef
            mat-header-cell
          >Devices
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            @if (isLocationsSummariesLoading()) {
              <ngx-skeleton-loader [theme]="{ height: '36px', marginBottom: 0, verticalAlign: 'top' }" />
            }
            @if (element.status === eEntityStatus.Active && !isLocationsSummariesLoading() && element.devicesByStatuses) {
              <avs-status-count
                [active]="element.devicesByStatuses.activeCount"
                [paused]="element.devicesByStatuses.pausedCount"
              />
            }
          </td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="action">
          <th
            [showForClientAdmin]="buildingDataFilterService.buildingStatusFilter === 'current'"
            *matHeaderCellDef
            avsRestrictedEl
            mat-header-cell
          ></th>
          <td
            [showForClientAdmin]="buildingDataFilterService.buildingStatusFilter === 'current'"
            *matCellDef="let element"
            avsRestrictedEl
            mat-cell
          >
            <div class="flex">
              @if (element.status !== eEntityStatus.Archived) {
                <a
                  class="mr-2"
                  [routerLink]="['/dashboard', element.id, 'edit']"
                  avsRestrictedEl
                  matTooltip="Edit Building"
                >
                  <i class="icon-edit action-icon"></i>
                </a>
                @if (element.status === eEntityStatus.Paused) {
                  <i
                    class="icon-play-16 action-icon test-resume-btn"
                    (click)="resumeSite(element)"
                    [showForClientAdmin]="true"
                    avsRestrictedEl
                    matTooltip="Resume"
                  ></i>
                }
                @if (element.status === eEntityStatus.Active) {
                  <i
                    class="icon-pause-16 action-icon"
                    (click)="pauseSite(element)"
                    [showForClientAdmin]="true"
                    avsRestrictedEl
                    matTooltip="Pause"
                  ></i>
                  <i
                    class="icon-add-to-archive action-icon test-pause-btn"
                    (click)="archiveSite(element)"
                    avsRestrictedEl
                    matTooltip="Archive"
                  ></i>
                }
              } @else {
                <i
                  class="action-icon icon-remove text-4xl"
                  (click)="deleteLocation(element)"
                  avsRestrictedEl
                  matTooltip="Delete"
                ></i>
                <i
                  class="action-icon icon-restore"
                  (click)="restoreSite(element)"
                  avsRestrictedEl
                  matTooltip="Restore"
                ></i>
              }
            </div>
          </td>
        </ng-container>

        <tr
          *matHeaderRowDef="displayedColumns; sticky: true"
          mat-header-row
        ></tr>
        <tr
          [class.is-offline]="row.status === eEntityStatus.Paused"
          *matRowDef="let row; columns: displayedColumns"
          mat-row
        ></tr>
      </table>
    </cdk-virtual-scroll-viewport-wrapper>
    @if (!dataSource.filteredData.length && locationsLoaded()) {
      <avs-no-data-placeholder
        [resultContent]="!!buildingDataFilterService.search || !!buildingDataFilterService.statusFilter || !!buildingDataFilterService.incidentFilter"
        noDataText="No buildings yet"
      />
    }
  </cdk-virtual-scroll-viewport>

}
